import { PanelbarStructure } from "../isPanelbarDetails";
import { Helper } from "../../util/helper";
import { StringKeyDictionary } from "../../../commonInterfaces";
import React from "react";
export default class ProcedureDetails extends React.Component<any, any> {
    private translations: StringKeyDictionary<string> = {};


    componentDidMount() {
        Helper.getTranslations(
            ["Field.Vorgang.problemnr", "Field.Vorgang.stufe", "Field.Vorgang.status", "Field.Vorgang.kommentar", "Field.Vorgang.termin1", "Field.Vorgang.problemkey", "Field.Vorgang.hotliner", "Field.Adresse.adrname", "Field.Vorgang.vorgangsstatus"])
            .then(result => {
                if (Helper.hasValue(result)) {
                    this.translations = result.Data;
                    this.setState({});
                }
            });
    }

    render() {
        const data = this.props.data;
        return (
            <PanelbarStructure label={data.ProblemNr} keyPropValue={data.ProblemNr} iconName={"exclamation-circle"} url={"Procedure/Edit?id=" + encodeURIComponent(data.ProblemNr)}>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span>{data.Kommentar}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.StatusInternBezeichnung}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{Helper.dates.toString(data.Termin1)}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Typ}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Hotliner}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.AdrName}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.StatusExtern}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}